import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder, NativeGeocoderOptions, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
import { Platform } from '@angular/cdk/platform';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { HandlerService } from './handler.service';
import { TrainerMapService } from './trainer-map.service';

declare var google;
@Injectable({
  providedIn: 'root'
})
export class Location1Service {

  constructor(private location: Geolocation,
    private platform:Platform,
    private ngZone: NgZone,
    private router: Router,  
    private nativeGeocoder: NativeGeocoder,
    private auth:AuthService,
    private service:ApiService,
    private handler:HandlerService) { }
   
    autoComp = null; houseNbr; zipcode; street; regionId;
    cityId; stateId; lat; lon; dummy = false;pop:boolean;newSearch;
    url;typeId;subscriptionId;markedPrice;trigger:boolean;serviceArea:boolean;locationTrue:boolean;
    // latitude;longtitude; 
    ionViewWillEnter(){
    }
    getLocation() {
      if(this.platform.ANDROID || this.platform.IOS){
        let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
        this.location.getCurrentPosition().then(res => {
          this.nativeGeocoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options)
            .then((result: NativeGeocoderResult[]) => {
              let x: any = result;
              localStorage.setItem('location', JSON.stringify(x));
            }, error => {
            
            });
        }, error => {
             })
      }
    }
  
    autoComplete() {
      if(!this.dummy){
        this.dummy = true;
        if (localStorage.getItem('location')) {
          let x = JSON.parse(localStorage.getItem('location'));
          this.autoComp = new google.maps.places.Autocomplete(event.target, { types: ['establishment','geocode'], componentRestrictions: { country: x[0].countryCode } })
        }
        else{
          this.autoComp = new google.maps.places.Autocomplete(event.target, { types: ['establishment','geocode'] })
        }
        this.autoComp.setFields(['address_component', 'geometry']);         
      }
      if (this.dummy) {
        this.autoComp.addListener("place_changed", () => {
          this.ngZone.run(() => {
            this.houseNbr = '';
            this.zipcode = '';
            this.street = '';
            this.cityId = '';
            this.regionId = '';
            this.stateId = '';
            this.onGetPlaces(this.autoComp.getPlace());
          });
        });
      }
     }
  
    onGetPlaces(data) {
     
      this.lat = data.geometry.location.lat();
      this.lon = data.geometry.location.lng();
      // this.latitude  = data.geometry.location.lat();
      // this.longtitude = data.geometry.location.lng();
      data.address_components.map(res => {
        if (res.types.includes("street_number")) {
          return this.houseNbr = res.long_name;
        }
        else if (res.types.includes("postal_code")) {
          return this.zipcode = res.long_name;
        }
        else if (res.types.includes("route")) {
          return this.street = res.long_name;
        }
        else if (res.types.includes("locality")) {
          return this.cityId = res.long_name;
        }
        else if (res.types.includes("sublocality")) {
          return this.regionId = res.long_name;
        }
        else if (res.types.includes("administrative_area_level_1")) {
          return this.stateId = res.long_name;
        }
        this.newSearch = "";
        this.pop = false;
     
      })
      setTimeout(() => {
        this.dummy = false;
      }, 1000);
      if(this.serviceArea){
        this.getLocationDetails();
        this.serviceArea = false;
      }
     
      localStorage.setItem('place', JSON.stringify(data.address_components));
    }
  
    getLocationDetails(){
      if(this.serviceArea){
      var post={
    "id":790,
    "region":this.regionId
      }
      this.service.locationSearch(post).subscribe((res:any)=>{
        if(res != null){
          this.locationTrue=true;
        }else{
          this.locationTrue=false;
          this.handler.err('Selected service is not provided in this region!!! Please select different region')
        }
      },err =>{
        this.handler.err(err)
      })
    }
    }
    openPop(){
      this.pop = true;
      this.trigger = true;
    }
  
    getCost(){
        if(this.trigger){
          var data={
            "itemTypeId": this.typeId,
            "region": this.zipcode,
            "serviceId":this.subscriptionId    
          }
          this.service.getCost(data).subscribe((res:any)=>{
            if(res!=null){
              this.markedPrice = res[0].cost;
            }else{
              this.handler.res("Please Select Different Location");
              this.markedPrice = "";
            }
          }, err => {
            this.handler.err(err);
          })
        }
    }
  
    ionViewWillLeave(){
      sessionStorage.removeItem('typeId');
      sessionStorage.removeItem('serviceId');
    }
  }